import {get, put} from '@/api/request.js'

const url = '/admin/ocr/use/model'
/**
 * 获取ocr使用模型
 * @returns {Promise<void>}
 */
export const get_ocr_model = async function () {
    return await get(url)
}


/**
 * 修改ocr使用模型
 * @param model{number} 使用模型
 * @returns {Promise<AxiosResponse<any>>}
 */
export const edit_ocr_model = async function (model) {
    return await put(url, {
        data: {
            model
        }
    })
}
